import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Animated, Platform, processColor, StyleSheet } from "react-native";
import createNativeWrapper from "../handlers/createNativeWrapper";
import GestureHandlerButton from "./GestureHandlerButton";
import { State } from "../State";
export var RawButton = createNativeWrapper(GestureHandlerButton, {
    shouldCancelWhenOutside: false,
    shouldActivateOnStart: false
});
var _React_Component;
export var BaseButton = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(BaseButton, _superClass);
    var _super = _create_super(BaseButton);
    function BaseButton(props) {
        _class_call_check(this, BaseButton);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "lastActive", void 0);
        _define_property(_assert_this_initialized(_this), "longPressTimeout", void 0);
        _define_property(_assert_this_initialized(_this), "longPressDetected", void 0);
        _define_property(_assert_this_initialized(_this), "handleEvent", function(param) {
            var nativeEvent = param.nativeEvent;
            var state = nativeEvent.state, oldState = nativeEvent.oldState, pointerInside = nativeEvent.pointerInside;
            var active = pointerInside && state === State.ACTIVE;
            if (active !== _this.lastActive && _this.props.onActiveStateChange) {
                _this.props.onActiveStateChange(active);
            }
            if (!_this.longPressDetected && oldState === State.ACTIVE && state !== State.CANCELLED && _this.lastActive && _this.props.onPress) {
                _this.props.onPress(active);
            }
            if (!_this.lastActive && // NativeViewGestureHandler sends different events based on platform
            state === (Platform.OS !== "android" ? State.ACTIVE : State.BEGAN) && pointerInside) {
                _this.longPressDetected = false;
                if (_this.props.onLongPress) {
                    _this.longPressTimeout = setTimeout(_this.onLongPress, _this.props.delayLongPress);
                }
            } else if (// cancel longpress timeout if it's set and the finger moved out of the view
            state === State.ACTIVE && !pointerInside && _this.longPressTimeout !== undefined) {
                clearTimeout(_this.longPressTimeout);
                _this.longPressTimeout = undefined;
            } else if (// cancel longpress timeout if it's set and the gesture has finished
            _this.longPressTimeout !== undefined && (state === State.END || state === State.CANCELLED || state === State.FAILED)) {
                clearTimeout(_this.longPressTimeout);
                _this.longPressTimeout = undefined;
            }
            _this.lastActive = active;
        });
        _define_property(_assert_this_initialized(_this), "onLongPress", function() {
            var _this_props_onLongPress, _this_props;
            _this.longPressDetected = true;
            (_this_props_onLongPress = (_this_props = _this.props).onLongPress) === null || _this_props_onLongPress === void 0 ? void 0 : _this_props_onLongPress.call(_this_props);
        });
        // Normally, the parent would execute it's handler first, then forward the
        // event to listeners. However, here our handler is virtually only forwarding
        // events to listeners, so we reverse the order to keep the proper order of
        // the callbacks (from "raw" ones to "processed").
        _define_property(_assert_this_initialized(_this), "onHandlerStateChange", function(e) {
            var _this_props_onHandlerStateChange, _this_props;
            (_this_props_onHandlerStateChange = (_this_props = _this.props).onHandlerStateChange) === null || _this_props_onHandlerStateChange === void 0 ? void 0 : _this_props_onHandlerStateChange.call(_this_props, e);
            _this.handleEvent(e);
        });
        _define_property(_assert_this_initialized(_this), "onGestureEvent", function(e) {
            var _this_props_onGestureEvent, _this_props;
            (_this_props_onGestureEvent = (_this_props = _this.props).onGestureEvent) === null || _this_props_onGestureEvent === void 0 ? void 0 : _this_props_onGestureEvent.call(_this_props, e);
            _this.handleEvent(e); // TODO: maybe it is not correct
        });
        _this.lastActive = false;
        _this.longPressDetected = false;
        return _this;
    }
    _create_class(BaseButton, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, rippleColor = _this_props.rippleColor, rest = _object_without_properties(_this_props, [
                    "rippleColor"
                ]);
                return /*#__PURE__*/ _jsx(RawButton, _object_spread_props(_object_spread({
                    rippleColor: processColor(rippleColor)
                }, rest), {
                    onGestureEvent: this.onGestureEvent,
                    onHandlerStateChange: this.onHandlerStateChange
                }));
            }
        }
    ]);
    return BaseButton;
}(_React_Component = React.Component);
_define_property(BaseButton, "defaultProps", {
    delayLongPress: 600
});
var AnimatedBaseButton = Animated.createAnimatedComponent(BaseButton);
var btnStyles = StyleSheet.create({
    underlay: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        top: 0
    }
});
var _React_Component1;
export var RectButton = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(RectButton, _superClass);
    var _super = _create_super(RectButton);
    function RectButton(props) {
        _class_call_check(this, RectButton);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "opacity", void 0);
        _define_property(_assert_this_initialized(_this), "onActiveStateChange", function(active) {
            var _this_props_onActiveStateChange, _this_props;
            if (Platform.OS !== "android") {
                _this.opacity.setValue(active ? _this.props.activeOpacity : 0);
            }
            (_this_props_onActiveStateChange = (_this_props = _this.props).onActiveStateChange) === null || _this_props_onActiveStateChange === void 0 ? void 0 : _this_props_onActiveStateChange.call(_this_props, active);
        });
        _this.opacity = new Animated.Value(0);
        return _this;
    }
    _create_class(RectButton, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, style = _this_props.style, rest = _object_without_properties(_this_props, [
                    "children",
                    "style"
                ]);
                var resolvedStyle = StyleSheet.flatten(style !== null && style !== void 0 ? style : {});
                return /*#__PURE__*/ _jsxs(BaseButton, _object_spread_props(_object_spread({}, rest), {
                    style: resolvedStyle,
                    onActiveStateChange: this.onActiveStateChange,
                    children: [
                        /*#__PURE__*/ _jsx(Animated.View, {
                            style: [
                                btnStyles.underlay,
                                {
                                    opacity: this.opacity,
                                    backgroundColor: this.props.underlayColor,
                                    borderRadius: resolvedStyle.borderRadius,
                                    borderTopLeftRadius: resolvedStyle.borderTopLeftRadius,
                                    borderTopRightRadius: resolvedStyle.borderTopRightRadius,
                                    borderBottomLeftRadius: resolvedStyle.borderBottomLeftRadius,
                                    borderBottomRightRadius: resolvedStyle.borderBottomRightRadius
                                }
                            ]
                        }),
                        children
                    ]
                }));
            }
        }
    ]);
    return RectButton;
}(_React_Component1 = React.Component);
_define_property(RectButton, "defaultProps", {
    activeOpacity: 0.105,
    underlayColor: "black"
});
var _React_Component2;
export var BorderlessButton = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(BorderlessButton, _superClass);
    var _super = _create_super(BorderlessButton);
    function BorderlessButton(props) {
        _class_call_check(this, BorderlessButton);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "opacity", void 0);
        _define_property(_assert_this_initialized(_this), "onActiveStateChange", function(active) {
            var _this_props_onActiveStateChange, _this_props;
            if (Platform.OS !== "android") {
                _this.opacity.setValue(active ? _this.props.activeOpacity : 1);
            }
            (_this_props_onActiveStateChange = (_this_props = _this.props).onActiveStateChange) === null || _this_props_onActiveStateChange === void 0 ? void 0 : _this_props_onActiveStateChange.call(_this_props, active);
        });
        _this.opacity = new Animated.Value(1);
        return _this;
    }
    _create_class(BorderlessButton, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, style = _this_props.style, rest = _object_without_properties(_this_props, [
                    "children",
                    "style"
                ]);
                return /*#__PURE__*/ _jsx(AnimatedBaseButton, _object_spread_props(_object_spread({}, rest), {
                    onActiveStateChange: this.onActiveStateChange,
                    style: [
                        style,
                        Platform.OS === "ios" && {
                            opacity: this.opacity
                        }
                    ],
                    children: children
                }));
            }
        }
    ]);
    return BorderlessButton;
}(_React_Component2 = React.Component);
_define_property(BorderlessButton, "defaultProps", {
    activeOpacity: 0.3,
    borderless: true
});
export { default as PureNativeButton } from "./GestureHandlerButton";
